import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getDecodeCookie, removeCookie } from 'common/Cookie';
import { SidebarSubMenu } from 'types/sidebar';
import { SidebarUserInfo } from 'types/user';
import { sideBarAdminMenuList, sideBarMenuList } from 'utils';
// import { sideBarDevMenuList } from 'utils/sidebarUtils';

interface Sidebar {
  userInfo: SidebarUserInfo | null;
  menu: SidebarSubMenu[];
}

// 메뉴를 가져오는 함수: isAdmin 여부에 따라 다른 메뉴 리스트를 반환
const getMenu = (userInfo: SidebarUserInfo | null) => {
  if (userInfo?.roles.includes('ROLE_ADMIN')) {
    return[
      ...sideBarAdminMenuList,
      // ...sideBarDevMenuList
    ] 
  }
  return sideBarMenuList;
};

// 초기 상태 설정
const initState: Sidebar = {
  userInfo: getDecodeCookie('accessToken') || null,
  menu: getMenu(getDecodeCookie('accessToken') || null)
};

// Slice 생성
const loginSlice = createSlice({
  name: 'LoginSlice',
  initialState: initState,
  reducers: {
    login: (state, action: PayloadAction<SidebarUserInfo>) => {
      state.userInfo = { ...action.payload };
      state.menu = getMenu(action.payload);
    },
    logout: (state) => {
      removeCookie('accessToken'); // 쿠키에서 accessToken 제거
      state.userInfo = null; // 유저 정보 초기화
      state.menu = sideBarMenuList; // 기본 메뉴로 설정
    }
  }
});

export const { login, logout } = loginSlice.actions;
export default loginSlice.reducer;
